<mat-progress-bar
  role="progressbar"
  aria-label="progressbar"
  class="loader-overlay"
  [class.hidden]="!(loaderState$ | async)?.show"
  mode="indeterminate"
  color="warn"
></mat-progress-bar>
